module.exports = __webpack_public_path__ + "img/nav-mense.8b3301ad.png";